module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAALCAYAAACd1bY6AAABCUlEQVQokZXSvyvFYRTH8de9ynB1M6G+k1gkNmWyoFAYDDLa/UNMBpKSgfJrNMgiA8rAcK02UgxCp55vXdf34p7p+XE+7895znlKWZadoYxpPGk9unCI54B0oxcnqLaI6sQx+oMTsBm8ow/7qPwT1IGjpHvBXMDu64DD2EX7H6BKMh7EKyZQK6fLG8yihFFso60JKIx2MII3TOFOanwel3XAcWwUAGO/hbH0ksi/zi/LDcnnWMBHSlxL8By0nir5xDwuvjlVqz8GWMMVFjGEnjTp1XQWRmF42iiMf9asySHYTFXcYiCtl3BQJCiqLI8APMTI0/+Lxi9jr5ngN1hEPPcRk1hJUy4OfAFzazJvEnvs+wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/family/list_time_arrow.png
// module id = tBM9
// module chunks = 1